export const allRevisionsUtils = {
    smallSampleSize: 100, // we only want some preview
};
